"use client";

import { Toaster } from "react-hot-toast";

export default function GlobalToaster() {
    return (
        <Toaster
            position="top-right"
            reverseOrder={false}
            gutter={8}
            containerClassName="toast-global-container"
            containerStyle={{
                zIndex: 999999999,
            }}
            toastOptions={{
                duration: 4000,
                style: {
                    background: "#fff",
                    color: "#363636",
                    padding: "16px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                },
                success: {
                    duration: 3000,
                    iconTheme: {
                        primary: "#10b981",
                        secondary: "#fff",
                    },
                },
                error: {
                    duration: 4000,
                    iconTheme: {
                        primary: "#ef4444",
                        secondary: "#fff",
                    },
                },
            }}
        />
    );
}
